import React from 'react';
import StatusLabel from 'components/status-label/StatusLabel';
import { __t, applyTranslations } from 'utils/language';
import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';
import { MixedSelectDropdownItem } from 'types';
import { EntertainmentVideoAudioType } from 'modules/entertainment-videos/types';
import { FormField } from 'components/form';

applyTranslations(require('./entertainment-video-audio-tags.i18n.json'));

function translate(path: string) {
  return __t(`entertainmentVideoAudio${path}`);
}

const AUDIO_OPTIONS = Object.values(EntertainmentVideoAudioType);

function getOptions(
  selectedOption: string | null
): Array<MixedSelectDropdownItem> {
  return AUDIO_OPTIONS.map((tag) => ({
    label: translate(`.enum.${tag}`),
    value: tag,
    identifier: tag,
    isDisabled: false,
    isFocused: false,
    isSelected: selectedOption === tag
  }));
}

export function EntertainmentVideoAudio({
  audioType,
  isEditMode = false,
  onTypeChange
}: {
  audioType: string | null,
  isEditMode?: boolean,
  onTypeChange?: (newType: string | null) => void
}) {
  if (isEditMode) {
    return (
      <FormField
        showValidationIcon={false}
        direction="column"
        fontSize="small"
      >
        <MixedSelectDropdown
          withRemovable
          className="realm-outfit-details-edit__compact-select"
          name="audio-type"
          withMulti={false}
          items={getOptions(audioType)}
          onItemsToggle={(_, __, selectedItem) => {
            if (typeof selectedItem?.value === 'string') {
              onTypeChange?.(selectedItem.value);
            }
          }}
          onItemsRemoveAll={() => {
            onTypeChange?.(null);
          }}
        />
      </FormField>
    );
  }

  if (!audioType) {
    return <span>–</span>;
  }

  return (
    <StatusLabel
      label={translate(`.enum.${audioType}`)}
      type="neutral"
      size="small"
    />
  );
}
